/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

window.Vue = require("vue");

import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";
import vSelect from "vue-select";
import VModal from "vue-js-modal";
import VuePrism from "vue-prism";
import carousel from 'vue-owl-carousel'
import Tabs from "vue-tabs-component";
import vueSmoothScroll from "vue-smooth-scroll";
import VueGoodTable from "vue-good-table";
import VueAutosize from "vue-autosize";
import { Money } from "v-money";
import VueTheMask from "vue-the-mask";
//import DatePicker from 'vue2-datepicker'
import Cleave from "vue-cleave-component";
import Loader from "./components/element/Loader.vue";
import notyModal from "./components/element/notyModal.vue";
import Multiselect from "vue-multiselect";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import Vuesax from 'vuesax';
import "vuesax/dist/vuesax.css";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import "material-icons/iconfont/material-icons.css";

Validator.localize("es", es);

/// Init
Vue.use(VeeValidate);
Vue.use(VModal);
Vue.use(notyModal)
Vue.use(VuePrism);
Vue.use(Tabs);
Vue.use(VueGoodTable);
Vue.use(Cleave);
Vue.use(VueTheMask);
Vue.use(vueSmoothScroll);
Vue.use(VueAutosize);
Vue.use(Vuesax, {
  // options here
});
//Vue.use(DatePicker)

/// Componentes
Vue.component('carousel', carousel);
Vue.component('notymodal', notyModal);
Vue.component("multiselect", Multiselect);
Vue.component("v-select", vSelect);
Vue.component("money", Money);
export default {
  components: { carousel },
}
Vue.component(
  "expandableContentButton",
  require("./components/element/ExpandableContentButton.vue")
);
Vue.component("input-field", require("./components/element/InputField.vue"));
Vue.component("expandableContentCheckbox", require("./components/element/expandableContentCheckbox.vue"));
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);
Vue.component(
  "textarea-field",
  require("./components/element/TextareaField.vue")
);
Vue.component("dropdown", require("./components/element/Dropdown.vue"));
Vue.component(
  "dropdown-notification",
  require("./components/element/DropdownNotification.vue")
);
Vue.component(
  "notificaciones",
  require("./components/element/Notificaciones.vue")
);
Vue.component("notification", require("./components/element/Notification.vue"));
Vue.component("loader", Loader);
Vue.component("kTable", require("./components/element/KTable.vue"));
Vue.component("datePicker", require("./components/element/DatePicker.vue"));
Vue.component(
  "checkedListbox",
  require("./components/element/CheckedListbox.vue")
);

/// Layout
Vue.component("kp-header", require("./components/layout/Header.vue"));
Vue.component("kp-logo", require("./components/layout/Logo.vue"));
Vue.component("kp-menu", require("./components/layout/menu/MainMenu.vue"));
Vue.component("kp-submenu", require("./components/layout/menu/Submenu.vue"));
Vue.component("kp-support", require("./components/layout/Support.vue"));
Vue.component("menu-search", require("./components/layout/menu/Search.vue"));
Vue.component("kp-user", require("./components/layout/UserStatus.vue"));

//Usuarios
Vue.component(
  "crearEditarUsuario",
  require("./components/forms/mantenimiento/usuarios/CrearEditarUsuario.vue")
);

//Reportes
Vue.component(
  "logsLogin",
  require("./components/forms/reportes/LogsLogin.vue")
);

//Cartera 
Vue.component(
  "cartera",
  require("./components/forms/Cartera.vue")
);

/// Mixins
Vue.mixin({
  methods: {
    route: route,
  },
});

axios.interceptors.request.use(
  function(config) {
    let id = uuid();
    let Modal = Vue.extend(Loader);
    let ModalComponent = new Modal({
      propsData: {
        name: id,
        loading: true,
      },
    }).$mount();
    app.$refs.app.appendChild(ModalComponent.$el);
    config.component = ModalComponent;
    config.id = id;
    app.$modal.show(id);
    return config;
  },
  function(error) {
    app.$modal.hide(error.config.id);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    app.$modal.hide(response.config.id);
    return response;
  },
  function(error) {
    app.$modal.hide(error.config.id);
    return Promise.reject(error);
  }
);

const app = new Vue({
  el: "#app",
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js